export const environment = {
  production: false,
  appName: 'BizCombo LAC Platform',
  apiBaseUrl: 'https://dev-billing-api.bizcombotech.com/api/licensing/v1',

  msalConfig: {
    auth: {
      clientId: 'b09c6538-1915-4cf7-a00b-0854e9aac09c',
      // Microsoft 365 / Entra ID tenant-restricted authority (BizCombo work accounts only)
      authority: 'https://login.microsoftonline.com/41748255-f1bf-4726-96f4-b96346ad4fef',
      redirectUri: '/',
      postLogoutRedirectUri: '/',
    },
  },

  apiConfig: {
    BillingAPI: {
      endpoint: 'https://dev-billing-api.bizcombotech.com/api/licensing/v1',
      scopes: {
        read: ['api://b09c6538-1915-4cf7-a00b-0854e9aac09c/User.Read'],
        write: ['api://b09c6538-1915-4cf7-a00b-0854e9aac09c/User.ReadWrite'],
      },
    },
  },
};
